import React, { useState, useEffect, useRef } from 'react';

import { getUserInitials } from '../../../utils/initialName';

import { CartIcon, UserIcon, EmailIcon, CloseIcon, MenuIcon, UserAnimationIcon } from '../../../assets/icons';
import GoogleLoginButton from '../../GoogleLoginButton';

const ButtonAuth = ({ mobile, onOpenMenu, close, user, isLoadingUser, refetchUser }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (modalOpen) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [modalOpen]);

  const openMobileModal = () => {
    setModalOpen(true);
    if (onOpenMenu) {
      onOpenMenu();
    }
  };

  const setRedirectLink = (type) => {
    const currentURL = window.location.href;
    const baseURL = `${process.env.REACT_APP_SITE_URL}/area-do-cliente/`;
    window.location.href = `${baseURL}${type}?redirect=${encodeURIComponent(currentURL)}`;
  };

  const renderDropdown = () => {
    if (isLoadingUser) {
      return <div className="loading">Carregando...</div>;
    }

    if (!user) {
      return (
        <React.Fragment>
          <div className="container_alert_description">
            <p className="text_description">Garanta descontos exclusivos e encontre os menores preços do mercado!</p>
          </div>
          <div className="container_auth_social">
            <GoogleLoginButton label="Acessar com o Google" refetchUser={refetchUser} />
          </div>
          <button className="button_email" onClick={() => setRedirectLink('login')}>
            <EmailIcon />
            Acessar com e-mail
          </button>
          <a className="close_link" onClick={() => setDropdownOpen(false)}>
            Continuar sem benefícios
          </a>
        </React.Fragment>
      );
    }

    const initials = getUserInitials(user.name || '');

    return (
      <React.Fragment>
        <div className="logged_in_header">
          <div className="avatar_user_large">{initials}</div>
          <div className="logged_in_header_text">
            <p>
              Olá, <strong>{user.name || ''}</strong>!
            </p>
          </div>
        </div>
        <nav className="nav_menu">
          <ul className="nav_menu_items">
            <li className="items">
              <a href={`${process.env.REACT_APP_SITE_URL}/area-do-cliente/meu-perfil`} className="dropdown_item">
                <UserIcon size={24} color="#007E47" />
                Ver minha conta
              </a>
            </li>
            <li className="items">
              <a href={`${process.env.REACT_APP_SITE_URL}/area-do-cliente/meus-pedidos`} className="dropdown_item">
                <CartIcon size={24} color="#007E47" />
                Meus pedidos
              </a>
            </li>
          </ul>
        </nav>
      </React.Fragment>
    );
  };

  if (isLoadingUser) {
    return (
      <button type="button" className="btn-out" disabled>
        <span>Carregando...</span>
      </button>
    );
  }

  const nameInitial = user ? getUserInitials(user.name) : '';

  if (mobile) {
    return (
      <button type="button" className="comp_header_menu" onClick={openMobileModal}>
        {close ? <CloseIcon color="#2E2E2E" /> : <MenuIcon color="#373737" />}
        {user ? (
          <div className="avatar_user_small">{nameInitial}</div>
        ) : (
          <React.Fragment>
            <UserAnimationIcon color="#2E2E2E" />
            <div className={close ? 'badge-mobile-close' : 'badge-mobile'} id="mobile-cart-badge">
              <span className="badge-number">1</span>
            </div>
          </React.Fragment>
        )}
        {!user && (
          <div className="tooltip-container visible">
            <span className="tooltip-text">Acesse ou crie sua conta</span>
          </div>
        )}
      </button>
    );
  }

  return (
    <div className="login-trigger-container" ref={dropdownRef}>
      <button type="button" className="btn-out" onClick={() => setDropdownOpen(!dropdownOpen)}>
        {user ? (
          <div className="avatar_user_small">{nameInitial}</div>
        ) : (
          <React.Fragment>
            <UserAnimationIcon color="#2E2E2E" />
            <div className="badge" id="cart-badge">
              <span className="badge-number">1</span>
            </div>
          </React.Fragment>
        )}
        <span id="login-btn-text">{user ? user.name.split(' ')[0] : 'Entrar'}</span>
      </button>
      {dropdownOpen && <div className="login-dropdown show">{renderDropdown()}</div>}
    </div>
  );
};

export default ButtonAuth;



// WEBPACK FOOTER //
// ./src/components/trigger_auth/buttonAuth/ButtonAuth.jsx